import React, { useEffect, useState } from 'react';
import RcSelect, { Option, SelectProps } from 'rc-select';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import ThickArrowRight from 'static/images/thick-arrow-right.svg';
import { Checkbox } from '../checkbox';
import './style.scss';

interface ISelectProps extends SelectProps {
    options: {value: string | number, label: string | number}[],
    values?: (string | number)[],
    className?: string,
    selectClassName?: string
}

export const Select = (props: ISelectProps) => {
    const {
        onChange = () => {}, values = [], options, className, selectClassName, ...other
    } = props;

    const { t } = useTranslation();

    const [ showDropdown, setShowDropDown ] = useState(false);
    const [ mutObserver, setMutObserver ] = useState(null);
    const [ optionsRef, setOptionsRef ] = useState(null);
    const [ placement, setPlacement ] = useState('');

    const mutationCallback = (mutationsList) => {
        mutationsList.forEach((mut) => {
            if (mut.attributeName === 'class') {
                const { classList } = mut.target;
                if (classList.contains('rc-select-dropdown-placement-topLeft')) {
                    setPlacement('top');
                } else if (classList.contains('rc-select-dropdown-placement-bottomLeft')) {
                    setPlacement('bottom');
                }
            }
        });
    };

    const initMutationObserver = () => {
        let dropDown = optionsRef?.parentNode.parentNode;
        let mutationObserver = new MutationObserver(mutationCallback);
        mutationObserver.observe(dropDown, { attributes: true });
        setMutObserver(mutationObserver);
    };

    useEffect(() => {
        if (optionsRef && !mutObserver) {
            initMutationObserver();
        }
    }, [ optionsRef ]);

    useEffect(() => mutObserver?.disconnect(), [ ]);

    const renderOptions = () => options.map(o => {
        const { value, label } = o;
        return (
            <Option value={value} key={value}>
                <div className="oms-checkbox-wrapper" onClick={e => e.preventDefault()}>
                    <Checkbox
                        checked={values !== null && (values.includes(value) || other.value === value)}
                        readOnly
                    />
                </div>
                <div className="option-value">
                    {label}
                </div>
            </Option>
        );
    });

    const addClass = {
        'bottom': placement === 'bottom',
        'top': placement === 'top'
    };

    return (
        <div
            className={clsx('select-wrapper', addClass, { 'open': showDropdown }, className)}
        >
            <RcSelect
                value={values === null ? undefined : values}
                onChange={onChange}
                dropdownClassName={clsx('select-dropdown', addClass)}
                className={clsx('select', selectClassName)}
                showArrow
                inputIcon={({ searchValue }) => (searchValue ? '' : <ThickArrowRight />)}
                notFoundContent="Не найдено"
                placeholder={t('Не выбрано')}
                showSearch={false}
                getPopupContainer={node => node.parentNode}
                onDropdownVisibleChange={open => setShowDropDown(open)}
                dropdownRender={(optsComponent) => (
                    <div
                        className="options-wrapper"
                        ref={(el) => setOptionsRef(el)}
                    >
                        {optsComponent}
                    </div>
                )}
                {...other}
            >
                {renderOptions()}
            </RcSelect>
        </div>
    );
};
